import helper from 'store/helper';
import types from 'store/capi-setting/types';
import { communicationStatus } from 'services/utils';
import { SORT_DIRECTION_DESC } from 'domain/settings/display-items';
import { UPDATE_DATE } from 'domain/fields';

const { IDLE, SUCCEEDED, FAILED } = communicationStatus;

const initialState = {
  data: {
    list: {
      data: [],
      metadata: {},
    },
    history: {},
    setting: {},
    masterData: {
      users: [],
      errors: [],
    },
  },
  settings: {
    sort: {
      field: UPDATE_DATE,
      direction: SORT_DIRECTION_DESC,
    },
  },
  errors: {
    list: [],
    setting: [],
  },
  status: {
    list: IDLE,
    setting: IDLE,
    history: IDLE,
    masterData: IDLE,
  },
};

const setStatus = (state, action) => {
  const { status, key } = action.payload;

  return {
    ...state,
    status: { ...state.status, [key]: status },
  };
};

const setData = (state, action) => {
  const {
    data: { data, metadata },
  } = action.payload;
  return {
    ...state,
    data: {
      ...state.data,
      list: {
        ...state.data.list,
        data,
        metadata,
      },
    },
    status: { ...state.status, list: SUCCEEDED },
  };
};

const setErrors = (state, action) => {
  const { key, errors } = action.payload;

  return {
    ...state,
    errros: { ...state.errors, [key]: errors },
    status: { ...state.status, [key]: FAILED },
  };
};

const updateSort = (state, action) => {
  const { field, direction } = action.payload;
  return {
    ...state,
    settings: {
      ...state.settings,
      sort: {
        field,
        direction,
      },
    },
  };
};

const setHistory = (state, action) => {
  const { data } = action.payload;
  return {
    ...state,
    data: {
      ...state.data,
      history: data,
    },
    status: { ...state.status, history: SUCCEEDED },
  };
};

const setStatusSetting = (state, action) => ({
  ...state,
  status: {
    ...state.status,
    setting: action.payload.status,
  },
});

const setErrorAuthentication = (state, action) => {
  return {
    ...state,
    data: {
      ...state.data,
      setting: {
        ...state.data.setting,
        errors: action.payload.errors,
      },
    },
    status: {
      ...state.status,
      setting: FAILED,
    },
  };
};

const setErrorSetting = (state, action) => ({
  ...state,
  data: {
    ...state.data,
    setting: {
      ...state.data.setting,
      errors: action.payload.errors,
    },
  },
  status: {
    ...state.status,
    setting: FAILED,
  },
});

const setDataSetting = (state, action) => ({
  ...state,
  data: {
    ...state.data,
    setting: {
      ...state.data.setting,
      item: action.payload.data,
      errors: [],
    },
  },
  status: {
    ...state.status,
    setting: SUCCEEDED,
  },
});

const setMasterData = (state, action) => ({
  ...state,
  data: {
    ...state.data,
    masterData: {
      ...state.data.masterData,
      ...action.payload.data,
      errors: [],
    },
  },
  status: { ...state.status, masterData: SUCCEEDED },
});

const CapiSettingReducer = helper.createReducer(initialState, {
  [types.SET_STATUS]: setStatus,
  [types.SET_DATA]: setData,
  [types.SET_ERRORS]: setErrors,
  [types.UPDATE_SORT]: updateSort,
  [types.SET_HISTORY]: setHistory,
  [types.SET_STATUS_SETTING]: setStatusSetting,
  [types.AUTHENTICATION_CHECK]: setErrorAuthentication,
  [types.SET_ERROR_SETTING]: setErrorSetting,
  [types.SET_DATA_SETTING]: setDataSetting,
  [types.SET_MASTERDATA]: setMasterData,
});

export default CapiSettingReducer;
